import { useMemo, useState } from "react";
import { Card, SectionHeader, TextInput } from "../../components/lib";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { SUBSCRIBERS, LAUNCH_PROJECTS, Subscriber } from "../../mocks/launchData";

function launchList(ids: string[]) {
  return ids.map((id) => LAUNCH_PROJECTS.find((l) => l.id === id)?.productName ?? id).join(", ");
}

export default function Subscribers() {
  const [tab, setTab] = useState<Subscriber["source"] | "all">("all");
  const [q, setQ] = useState("");
  const filtered = useMemo(() => SUBSCRIBERS.filter((s) =>
    (tab === "all" || s.source === tab) &&
    (!q || s.name.toLowerCase().includes(q.toLowerCase()) || s.city.toLowerCase().includes(q.toLowerCase())),
  ), [tab, q]);

  const expected = SUBSCRIBERS.reduce((s, x) => s + x.ltvExpectedEGP, 0);

  return (
    <div className="space-y-6" data-testid="ln-subs">
      <Card testId="ln-sub-summary">
        <SectionHeader eyebrow="Waitlist" title={`${SUBSCRIBERS.length} subscriber${SUBSCRIBERS.length === 1 ? "" : "s"}`} />
        <div className="grid grid-cols-3 gap-4">
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Expected LTV total</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-success)" }}>EGP {(expected/1000).toFixed(0)}K</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Highest-value subscriber</div><div className="text-sm mt-1" style={{ color: "var(--ph-ink-strong)" }}>{SUBSCRIBERS.length === 0 ? "—" : (SUBSCRIBERS.slice().sort((a,b) => b.ltvExpectedEGP - a.ltvExpectedEGP)[0]?.name ?? "—")}</div></div>
          <div><div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>New this week</div><div className="text-xl font-semibold tabular-nums mt-1" style={{ color: "var(--ph-ink-strong)" }}>{SUBSCRIBERS.filter((s) => s.joinedRelative.includes("d ago") || s.joinedRelative === "yesterday").length}</div></div>
        </div>
      </Card>

      <Card testId="ln-sub-filters">
        <TextInput value={q} onChange={setQ} placeholder="Search subscribers by name or city…" testId="ln-sub-search" />
        <div className="mt-4">
          <TabBar<Subscriber["source"] | "all">
            testId="ln-sub-tabs"
            active={tab}
            onChange={setTab}
            tabs={[
              { key: "all",      label: "All"      },
              { key: "IG",       label: "Instagram"},
              { key: "TikTok",   label: "TikTok"   },
              { key: "Web",      label: "Web"      },
              { key: "Retail",   label: "Retail"   },
              { key: "Referral", label: "Referral" },
            ]}
          />
        </div>
      </Card>

      <Card padded={false} testId="ln-sub-list-card">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Subscribers" title={`${filtered.length}`} />
        </div>
        <div className="p-2">
          {filtered.map((s) => (
            <ListRow key={s.id} testId={`ln-sub-${s.id}`}
              label={<span>{s.name}</span>}
              sublabel={<>{s.city} · {s.source} · {s.joinedRelative} · interested in {launchList(s.interestedIn)}</>}
              trailing={<span className="text-sm tabular-nums" style={{ color: "var(--ph-ink-strong)" }}>LTV EGP {(s.ltvExpectedEGP/1000).toFixed(0)}K</span>}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
